import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import {
  connectionsContract,
  type ConnectionsContract,
} from "@typedoc/contracts/connections/contract";
import { contractLink, type ContractCallContext } from "../contract-client";

export type ConnectionsClient = ContractRouterClient<ConnectionsContract, ContractCallContext>;

/** The Connections API through its contract; each call names its region and token. */
export const connectionsClient: ConnectionsClient = createORPCClient(
  contractLink(connectionsContract),
);
